<template>
  <v-card class="dialog-card">
    <ModalHeader
      helpFileName="AddOrEditTag"
      icon="mdi-tag-plus"
      :modalTitle="'Add Tag'"
      @close="emit('close')" />

    <div
      :class="'mx-3 pa-3'"
      style="border-radius: 5px">
      <div
        if
        v-if="protectedTag"
        class="mb-3">
        <v-alert
          icon="mdi-tag-off"
          title="Protected Tag"
          text="This is a system or default tag and cannot be edited."
          variant="tonal"
          color="error"></v-alert>
      </div>

      <v-text-field
        :disabled="protectedTag"
        filled
        background-color="textBoxBackground"
        label="Name"
        v-model="new_tag.name"
        style="height: 66px"
        bg-color="var(--inner-background) !important"
        color="var(--text) !important"
        v-on:keyup.enter="protectedSave()"></v-text-field>
      <div style="display: flex; justify-content: center">
        <v-color-picker
          :disabled="protectedTag"
          dot-size="25"
          :swatches="swatches"
          hide-canvas
          hide-inputs
          hide-sliders
          show-swatches
          hex
          :width="500"
          v-model="current_tag_color"
          swatches-max-height="200"
          swatches-max-width="500"></v-color-picker>
      </div>
    </div>

    <div class="modal-footer">
      <v-btn
        v-if="selected"
        :disabled="protectedTag"
        color="primary"
        class="mr-2"
        style="background-color: var(--inner-background)"
        variant="flat"
        @click="remove_tag">
        <v-icon style="font-size: 22px">mdi-trash-can</v-icon>
      </v-btn>
      <v-spacer />
      <v-btn
        :disabled="new_tag.name == '' || protectedTag"
        :loading="loading_create"
        color="primary"
        variant="flat"
        @click="protectedSave()">
        <v-icon class="ml-1 mr-2">mdi-content-save</v-icon>
        Save
      </v-btn>
    </div>
  </v-card>
</template>
<script setup>
import { onMounted, ref, defineProps, computed } from 'vue';
import { $http } from '../../stores/http.js';
import HelpButton from '../Help-Hints/HelpButton.vue';
import ModalHeader from '../Shared/Modals/ModalHeader.vue';

const emit = defineEmits(['close', 'newTag']);

const props = defineProps(['selected']);

const protectedTag = computed(() => {
  return props.selected?.protection_level > 0;
});

async function protectedSave() {
  if (protectedTag.value) {
    return;
  }

  await create_tag();
}

const swatches = [
  ['#5d6ae3', '#725de3', '#9d5de3'],
  ['#cb5de3', '#e35dcc', '#e35d92'],
  ['#e35d66', '#e3765d', '#e39b5d'],
  ['#e3b75d', '#e3dc5d', '#c5e35d'],
  ['#62e35d', '#5de39c', '#5ddae3'],
  ['#5dc1e3', '#5d93e3', '#5d74e3'],
  ['#626262', '#2e2e2e', '#141414'],
];
const new_tag = ref({
  name: '',
});
const current_tag_color = ref('#5d6ae3');
const loading_create = ref(false);
const loading_delete = ref(false);
onMounted(() => {
  if (props.selected) {
    new_tag.value.name = props.selected.name;
    current_tag_color.value = props.selected.color;
  }
});
function remove_tag() {
  loading_delete.value = true;
  $http('DELETE', '/delete_tag?tag_uid=' + props.selected.uid).then(() => {
    loading_delete.value = false;
    emit('close');
  });
}
async function create_tag() {
  loading_create.value = true;
  if (new_tag.value.name) new_tag.value.name.trim();
  if (!new_tag.value.name) {
    alert('Please enter a tag name');
  } else {
    if (props.selected) {
      new_tag.value.color = current_tag_color.value;
      new_tag.value.uid = props.selected.uid;
      $http('PUT', '/edit_tag', JSON.stringify(new_tag.value)).then(() => {
        loading_create.value = false;

        emit('close');
      });
    } else {
      new_tag.value.color = current_tag_color.value;
      const resp = await $http(
        'POST',
        '/create_tag',
        JSON.stringify(new_tag.value)
      );
      loading_create.value = false;
      emit('newTag', JSON.parse(resp));
      emit('close');
    }
  }
}
</script>
